import { useContext } from "react";

import { Box, Icon, useTheme } from "@seneca/senekit";

import { SidebarContext } from "../../SidebarContextProvider";

type Props = {
  onClick: () => void;
};

export default function DividerCollapse({ onClick }: Props) {
  const theme = useTheme();
  const color = theme["neutral-xLow-content"];
  const width = "100%";
  const height = "1px";

  const { collapsed } = useContext(SidebarContext);

  return (
    <Box
      width={width}
      height={height}
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      <Box width={width} height={height} backgroundColor={color} />
      <Box
        onClick={onClick}
        paddingX="large"
        paddingY="medium"
        borderRadius="small"
        transition="0.4s"
        transform={collapsed ? "none" : "rotate(180deg)"}
        hoverStyles={{
          cursor: "pointer",
          backgroundColor: theme["neutral-medium-surface"]
        }}
      >
        <Icon
          iconName="caretDoubleDown"
          accessibilityLabel={collapsed ? "expand" : "collapse"}
          tone="neutral"
          emphasis="low"
        />
      </Box>
      <Box width={width} height={height} backgroundColor={color} />
    </Box>
  );
}
